import styled from 'styled-components';

import { Box } from '@/components/Box';

export const ShareWrapper = styled(Box)``;
